// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"d7d270a9","707":"3424a9dc","729":"4efe17f2"}[chunkId] + ".js";
};